var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-form-group",
    _vm._b(
      { attrs: { label: _vm.label, description: _vm.description } },
      "b-form-group",
      _vm.$attrs,
      false
    ),
    [
      _c("template", { slot: "label" }, [
        _vm._v("\n        " + _vm._s(_vm.label)),
        _vm.required
          ? _c("span", { staticClass: "text-danger" }, [_vm._v("*")])
          : _vm._e()
      ]),
      _vm._v(" "),
      _vm._t("default")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }